import { render, staticRenderFns } from "./chanyeyongdi.vue?vue&type=template&id=229d1373&scoped=true&"
import script from "./chanyeyongdi.vue?vue&type=script&lang=js&"
export * from "./chanyeyongdi.vue?vue&type=script&lang=js&"
import style0 from "./chanyeyongdi.vue?vue&type=style&index=0&id=229d1373&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d1373",
  null
  
)

export default component.exports